import { Component, OnInit } from '@angular/core';
import { PageNavigationService } from '../../shared/services/page-navigation.service';
import { LayoutService } from '../../shared/services/layout.service';
import { STATIC_VALUE } from './../../shared/configuration/static.value';

@Component({
    selector: 'information-contact-us',
    templateUrl: 'contact-us.component.html'
})
export class InformationContactUsComponent {
    constructor(
        private _pageNavigationService: PageNavigationService,
        private _layoutService: LayoutService
    ){}

    ngOnInit(){
        this._layoutService.setCurrentPage('information-contact-us');
    }

    goToLogin() {
        let vLink:any = ['login'];
        this._pageNavigationService.navigate(vLink);
    }
    Contactus()
    {
        return STATIC_VALUE.CONTACTUS;
    }

}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/information/components/contact-us.component.ts